import Request from './request';
import store from '@/store.js';

async function fetchList() {
    return Request('get', "api/announcements");
}

async function readShopAnnouncement(data) {
    return Request('get', "api/announcements/read-shop-announcement", data);
}

async function getUnreadShopAnnouncementsCount() {
    const response = await Request('get', "api/announcements/get-unread-shop-announcements-count");
    if (response.data && response.data.status.isOK()) {
        store.commit("unReadNotice", response.data.announcements);
    }
    return response;
}


export default {
    fetchList,
    readShopAnnouncement,
    getUnreadShopAnnouncementsCount,
}
